<div class="h-[100vh] min-w-full bg-gray-900">
    <div class="flex flex-col gap-10 p-20">
        <h1 class="text-white">Testing Component</h1>
        <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
            <div class="nowrap flex flex-row gap-3">
                <!-- Cash -->
                <mat-form-field class="mat-form-field-cleaner w-80">
                    <mat-label class="font-bold text-white"> Cash </mat-label>
                    <input
                        class="input text-end"
                        leafInput
                        matInput
                        (keydown)="onKeyDown($event)"
                        [placeholder]="'0'"
                        formControlName="testing"
                        validateFloat
                        appMaxLength="5"
                        cashInput
                        required
                    />
                    @if (formGroup.get('testing').hasError('required')) {
                        <mat-error> Cash is required </mat-error>
                    }
                </mat-form-field>
            </div>

            <!-- CTAs -->
            <!-- <div class="dialog__cta-container">
                <button class="btn btn-primary" type="submit">Save</button>
                <button class="btn btn-secondary" mat-dialog-close>
                    Cancel
                </button>
            </div> -->
        </form>

        <!-- <div class="happy-face"></div> -->
        <div class="gradient-progress-bar"></div>

        <button class="btn btn-primary" (onClick)="loadDialog()">
            Load Sample Dialog
        </button>
    </div>
</div>
